import svg4everybody from 'svg4everybody';
import 'lazysizes';
import 'objectFitPolyfill';
import Nav from './components/Nav';
import HomeHeader from './components/HomeHeader';
import ReceptenSlider from './components/ReceptenSlider';
import Video from './components/Video';
import Cookie from './components/Cookie';
import 'swiper/swiper-bundle.css';

Nav.init();
HomeHeader.init();
ReceptenSlider.init();
Video.init();
Cookie.init();

window.objectFitPolyfill();

window.addEventListener('load', () => {
    // SVG fallback
    svg4everybody();
});
